//IMPORTAÇÕES
import React, { useState, useEffect } from 'react';/*eslint-disable*/
import 'moment-timezone';/*eslint-disable*/
import {formatarData} from '../../../utils/formatadorDataTabela'/*eslint-disable*/
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import { useDispatch, useSelector, connect } from 'react-redux';
import {api} from '../../../conexoes/api';
import BootstrapTable from 'react-bootstrap-table-next';
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import decryptJWT from '../../../utils/decryptJWT'
import { formatarMilhar } from '../../../utils/formatarMilhar';


//COMPONENTES
import PaginacaoTabela from '../../../utils/paginacaoTabela'
import BarraFiltragem from '../../componentesModais/barraFiltragem/barraFiltragem'
import BarraDadosCliente from '../../componentesModais/barraDadosCliente/barraDadosCliente'
import NovoPedido from './novoPedido/novoPedido'
// SPINNER
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'
// COLETA CLICKSTREAM
import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'

//REDUX
import { revelarNovoPedidoImportado, mudarManejador, limpouBusca, realizouBusca, desabilitarAcoes, desabilitarAcoesCliente, mudarFiltros, 
    revelarBarraFiltragem, realizouFiltro, limpadorFiltros, revelarDeletarPedidoImportado } from "../../../redux/actions/index"
    
const valorLimite = 3
let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let itensVar = []

function TabelaPedido(props){
    //HOOKS TABELA
    const [itens, setItens] = useState("");
    const [paginaAtual, setPaginaAtual] = useState(1);
    const [renderizar, setRenderizar] = useState(false);
    const [valorLimite, setValorLimite] = useState(50);
    const [envioSelecionado, setEnvioSelecionado] = useState([])
    const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
    const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
    const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
    const [cd_pav_cliente, setCd_pav_cliente] = useState(decryptJWT("codigoCliente"))
    const conteudoBusca = useSelector(state => state.manejadorState.conteudoBusca);
    const limpouBuscaGeral = useSelector(state => state.manejadorState.limpouBusca);
    const realizouBuscaGeral = useSelector(state => state.manejadorState.realizouBusca);
    const revelarBarraFiltro = useSelector(state => state.filtrosState.revelarBarraFiltragem);
    const realizouFiltragem = useSelector(state => state.manejadorState.realizouFiltro);
    const revelarNovoPedido = useSelector(state => state.manejadorState.revelarNovoPedidoImportado);
    const revelarDeletarPedido = useSelector(state => state.manejadorState.revelarDeletarPedidoImportado);
    const visualizarDados =  useSelector(state => state.virtueyesState.visualizarDados);
    // SPINNER
    const [spinAtivo, setSpinAtivo] = useState(false);
    

    //REDUX VARIÁVEIS
    const despacho = useDispatch();
    const filtros = useSelector(state => state.filtrosState.filtros);

    

    useEffect(()=>{
        despacho(revelarBarraFiltragem(false))
        if(!filtros.vazio){
            despacho(mudarFiltros({vazio: 'vazio'}))
        }
        despacho(limpadorFiltros(true))
    }, [])
    

    useEffect(() => {
        setSpinAtivo(true)
        //despacho redux
        despacho(mudarManejador("pedidoImporta"));
        despacho(desabilitarAcoes(true));
        despacho(desabilitarAcoesCliente(true));
        async function carregarTabela(){
            // //clicou no botão de limpar a busca geral e retorna tudo ao estado original
            if(limpouBuscaGeral){
                despacho(limpouBusca(false));
                restaurarConfigsIniciaisPagina()
            }

            //clicou no botão de busca geral
            if(realizouBuscaGeral){
                despacho(realizouBusca(false));
                restaurarConfigsIniciaisPagina()
            }    

            //clicou no botão para filtro
            if(realizouFiltragem){
                despacho(realizouFiltro(false));
                restaurarConfigsIniciaisPagina()
            }

            if(conteudoBusca  && filtros.vazio){
                if(totalPaginas == 0){
                    contador = 0;
                    itensVar = [];
                    setItens([])
                    await contarItens();
                }
                else{
                    contador = (paginaAtual - 1) * valorLimite;
                }
                if (controladorPagina <= paginaAtual) {
                    await contarItens();
                    const { data } = await api.get('/m1/consultar/pedido_importado?paginaAtual='+contador+'&carregarLimit='+valorLimite+'&buscar='+conteudoBusca);
                    inserirData(data.dados)
                }
            }else if(!filtros.vazio){
                if(totalPaginas == 0){
                    contador = 0;
                    itensVar = [];
                    setItens([])
                    await contarItens();
                }else{
                    contador = (paginaAtual - 1) * valorLimite;
                }
                const dados = {
                    paguinaAtual: contador,
                    carregarLimit: valorLimite,
                    buscar:conteudoBusca,
                    filtros: filtros
                }
                if (controladorPagina <= paginaAtual) {
                    const { data } = await api.post("/m1/consultar/pedido_importado", dados);
                    inserirData(data.dados)
                }
            }else{
                if(totalPaginas == 0){
                    await contarItens();
                }else{
                    contador = (paginaAtual - 1) * valorLimite;
                }
                if (controladorPagina <= paginaAtual) {
                    const { data } = await api.get('/m1/consultar/pedido_importado?paginaAtual='+contador+'&carregarLimit='+valorLimite);
                    inserirData(data.dados)
                }
            }
            setSpinAtivo(false)
        }
        carregarTabela();
    }, [paginaAtual, conteudoBusca, renderizar, filtros])

  
    function inserirData(data){
        for(let i=0;i<totalItens;i++){
            if (contador === i){
                let k = i
                for(let j=0;j<data.length;j++){
                    itensVar[k] = data[j]
                    k++
                }
            }
            if(i == (totalItens-1)){
                setItens(JSON.parse(JSON.stringify(itensVar)))
            }
        }
    }
    
    async function contarItens(){
        let arrayItens = []
        let apiData = []
        if (controladorPagina <= paginaAtual && filtros.vazio) { 
            apiData = await api.get('/m1/consultar/pedido_importado?contar=true&buscar='+conteudoBusca);
        }else{
            const dados = {
                paguinaAtual: contador,
                carregarLimit: valorLimite,
                buscar:conteudoBusca,
                contar:true,
                filtros: filtros
            }
            apiData = await api.post("/m1/consultar/pedido_importado", dados);
        }
        itensVar = []
        if(apiData.data.dados){
            totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
            totalItens = apiData.data.dados[0].CONTADOR;
            for( var i = 0 ; i < apiData.data.dados[0].CONTADOR; i++){
                arrayItens.push(i)
            }
            itensVar = arrayItens
        }
    }

    function restaurarConfigsIniciaisPagina(){
        totalPaginas = 0
        contador = 0
        controladorPagina = 1
        totalItens = 0
        setPaginaAtual(1)
    }
     
    function handleMensagemSucesso(confirmacao){
        if(revelarMensagemSucesso === false){
            setRevelarMensagemSucesso(true)
        }else{
            setRevelarMensagemSucesso(false)
            setRenderizar(!renderizar)
            restaurarConfigsIniciaisPagina()
            if(confirmacao === true){
                //ALGUMA FUNÇÃO
            }
        }
    }

    function handleMensagemErro(confirmacao){
        if(revelarMensagemErro === false){
            setRevelarMensagemErro(true)
        }else{
            setRevelarMensagemErro(false)
            setRenderizar(!renderizar)
            if(confirmacao === true){
                //ALGUMA FUNÇÃO
            }
        }
    }

    function handleMensagemAtencao(confirmacao){
        if(revelarMensagemAtencao === false){
            setRevelarMensagemAtencao(true)
        }else{
            setRevelarMensagemAtencao(false)
            if(confirmacao === true){
                handlerDeletarPedido()
            }
        }
    }

    async function handlerDeletarPedido(){
        setSpinAtivo(true)
        await api.get('/m1/deletar/pedido_importado?cd_dsp_pedido_importado='+envioSelecionado.cd_dsp_pedido_importado)
                .then((response)=>{
                    if(response.data.status == 200){
                        setRevelarMensagemSucesso(true)
                    }
                    else{
                        setRevelarMensagemErro(true)
                    }
                })
                .catch((error)=>{
                    setRevelarMensagemErro(true)
                })
        setSpinAtivo(false)
    } 

    useEffect(()=>{
        if(revelarDeletarPedido){
            
            setRevelarMensagemAtencao(true)
            despacho(revelarDeletarPedidoImportado(false))
        }
    },[revelarDeletarPedido])

    const colunas = [
        {
            dataField: 'cd_dsp_pedido_importado',
            headerClasses: 'nao-selecionavel',
            text: 'Código',
            sort: false,
            formatter: (cell, row) => {
                return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
            }
        },
        {
            dataField: 'cd_pav_cliente',
            headerClasses: 'nao-selecionavel',
            text: 'Código cliente',
            sort: false,
            hidden: true,
            formatter: (cell, row) => {
                return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
            }
        },
        {
            dataField: 'ds_pav_cliente',
            headerClasses: 'nao-selecionavel',
            text: 'Cliente',
            sort: false,
            formatter: (cell, row) => {
                return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
            }
        },
        {
            dataField: 'cd_pav_usuario_created',
            headerClasses: 'nao-selecionavel',
            text: 'cd_pav_usuario_created',
            hidden: true,
            sort: false,
            formatter: (cell, row) => {
                return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
            }
        },
        {
            dataField: 'ds_email',
            headerClasses: 'nao-selecionavel',
            text: 'Usuário',
            sort: false,
            formatter: (cell, row) => {
                return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
            }
        },
        {
            dataField: 'ds_descricao',
            headerClasses: 'nao-selecionavel',
            text: 'Descrição',
            sort: false,
            
            formatter: (cell, row) => {
                return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
            }
        },
        {
            dataField: 'qtd_simcards',
            headerClasses: 'nao-selecionavel',
            text: 'Quantidade de SIM cards',
            sort: false,
            formatter: (cell, row) => {
                const valor = parseFloat(cell);
                return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
            }
        },
        {
            dataField: 'dt_created_at',
            headerClasses: 'nao-selecionavel',
            text: 'Data de criação',
            sort: false,
            formatter: (cell, row) => {
                return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
            }
        },
    ]
    
    const eventosLinhas = {
        onClick: (e, row, rowIndex) => {
            setEnvioSelecionado(row)
        }
    }
    
    
    const opcoesPaginacao = {
        page: paginaAtual,
        showTotal: true,
        sizePerPage: valorLimite,
        firstPageTitle: 'Primeira',
        lastPageTitle: 'Última',
        nextPageTitle: 'Proxima',
        prePageTitle: 'Anterior',
        custom: true,
        onPageChange:(page) => {setPaginaAtual(page)}
    }

    const selecaoLinhas = {
        mode: 'radio',
        onSelect: (row, isSelect, rowIndex, e) => {
            if(isSelect){
                setEnvioSelecionado(row)
                despacho(desabilitarAcoes(false));
            }
        },
        selectionRenderer: ({ mode, ...rest }) => {
            return (
                <label className="label-checkbox-cliente-virtueyes fonte-cor-1">
                    <input type={mode} id=" CLIENTEVEYE" name="CLIENTE"/>
                    <span className="checkbox-cliente-virtueyes radio-button-cor-1"></span>
                </label>
            )
        }
    };

    return(
        <div className='container-tela'>
            {visualizarDados === true &&
                <BarraDadosCliente/>
            }
        { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
         
        
            {revelarNovoPedido === true &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal-tabela-novo-pedido-container">
                        <NovoPedido
                            setRenderizar={setRenderizar}
                            renderizar={renderizar}
                        >
                        </NovoPedido>
                    </div>
                </div>
            }
            
            { revelarMensagemSucesso &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <MensagemSucesso
                            handleMensagemSucesso={handleMensagemSucesso}
                            mensagemTitulo={"Sucesso"}
                            mensagemParagrafo1={"Pedido deletado com sucesso"}
                            mensagemBotao={"OK"}
                        />
                    </div>
                </div>
            }
            { revelarMensagemErro &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <MensagemErro
                            handleMensagemErro={handleMensagemErro}
                            mensagemTitulo={"Erro"}
                            mensagemParagrafo1={"Algo deu errado. Por favor tente novamente mais tarde."}
                            mensagemParagrafo2={"Caso o erro persista, entre em contato com o suporte."}
                            mensagemBotao={"Retornar"}
                        />
                    </div>
                </div>
            }

            { revelarMensagemAtencao &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <MensagemAtencao
                            handleMensagemAtencao={handleMensagemAtencao}
                            mensagemTitulo={"Tem certeza que deseja deletar o pedido?"}
                            mensagemParagrafo1={"Pedidos deletados deletarão linhas do pedido"}
                            mensagemBotao={"Deletar"}
                        />
                    </div>
                </div>
            }

            { revelarBarraFiltro === true &&
                <BarraFiltragem/>
            }

            <PaginationProvider pagination={Paginador(opcoesPaginacao)} >
                {
                    ({
                        paginationProps,
                        paginationTableProps
                    }) => (
                        <>
                            <BootstrapTable
                                hover={true}
                                condensed={true}
                                keyField='cd_dsp_pedido_importado' 
                                data={itens} 
                                columns={colunas} 
                                rowEvents={eventosLinhas}
                                bootstrap4={true}
                                bordered={false}
                                selectRow={ selecaoLinhas }
                                classes="tabela"
                                noDataIndication={!spinAtivo && "Nenhum item encontrado"}
                                { ...paginationTableProps }
                            />
                             <PaginacaoTabela
                                setPaginaAtual={setPaginaAtual}
                                totalPaginas={totalPaginas}
                                totalItens={totalItens}
                                valorLimite={valorLimite}
                                paginaAtual={paginaAtual}
                                page={paginationProps.page}
                                onPageChange={paginationProps.onPageChange}
                            />
                        </>
                    )
                }
            </PaginationProvider>
            <text className="itens-exibidos-tabela fonte-cor-1">
                Mostrando 
                <span className="label-tabela-itens-exibidos">{contador + 1}</span>
                    - 
                <span className="label-tabela-itens-exibidos">{ contador + valorLimite <= totalItens ? contador + valorLimite : totalItens }</span>
                    de 
                <span className="label-tabela-itens-exibidos">{totalItens}</span>
            </text>
           
        </div>
    )
}

function mapStateToProps(state) {
    return { conteudoBusca: state.manejadorState.conteudoBusca, filtros: state.filtrosState.filtros };
} 
//React.memo - nao permitir a renderizacao se o state e o props nao mudarem de estado
export default connect(mapStateToProps)(React.memo(TabelaPedido));